import styled from 'styled-components';

export default styled.div`
  background-color: ${({ theme }) => theme.COLOR_GRAY_LIGHTEST};
  padding: 2rem;
`;
